/*
 * @Author: your name
 * @Date: 2021-08-22 16:10:29
 * @LastEditTime: 2024-03-29 14:20:26
 * @LastEditors: bobo 350910378@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \my-app\src\global\BsyFormulaCalcParser.js
 */
import Big from 'big.js';
import {BsyFormulaCalc} from './FormulaCalc'
import {BsyFormula} from './Formula'

const calc = new BsyFormulaCalc();

export const BsyFormulaCalcParser = {
    evalExpression: function(op, left, right) {
        var calcOps = ["+", "-", "*", "/"];
        if ("!" === op) {
            // eslint-disable-next-line no-eval
            return eval(op + "left");
        }

        if (calcOps.indexOf(op) > -1 && BsyFormulaCalcParser.isValidNumber(left) && BsyFormulaCalcParser.isValidNumber(right)) {
            var result;
            switch (op) {
                case '+': {
                    result = new Big(left).plus(right);
                    break;
                }
                case "-":
                    result = new Big(left).minus(right);
                    break;
                case "*":
                    result = new Big(left).times(right);
                    break;
                case "/":
                    result = 0 === right ? "" : new Big(left).div(right)
                    break;
                default: 
                    break;
            }
            return "" === result ? null : Number(result.toString())
        }
        // eslint-disable-next-line no-eval
        return eval("left" + op + "right")
    },
    isValidNumber: function (t) {
        // if(num === null) {
        //     return false;
        // }
        // const t = Number(num);
        return "number" === typeof t && !isNaN(t) && isFinite(t)
    },
    applyFunc: function(t, e) {
        if (BsyFormula[t])
            return BsyFormula[t].apply(null, e)
    },
    parse: function(t) {
        return calc.parse(t)
    }
}